import { render } from "./AlbumList.vue?vue&type=template&id=c770c5b2&scoped=true"
import script from "./AlbumList.vue?vue&type=script&lang=js"
export * from "./AlbumList.vue?vue&type=script&lang=js"

import "./AlbumList.vue?vue&type=style&index=0&id=c770c5b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c770c5b2"]])

export default __exports__